export default "__VITE_ASSET__8d8b1e80__"